export default __webpack_public_path__ + "img/upuflogo.507af686.png";